import store from '@/store'

// Theme manager
export default {
    // Initialize theme
    init (): void {
        // Get theme from environment variable or fallback to blue
        const configTheme = process.env.VUE_APP_THEME || 'blue'

        // Use theme from config
        this.setTheme(configTheme)
    },

    // Set theme
    setTheme (theme: string): void {
        // Update theme in store
        store.commit('setTheme', theme)

        // Dynamically import theme styles
        import(`@/stylus/themes/${theme}.styl`)
            .catch(err => {
                console.error('Failed to load theme:', err)
                // If loading fails, fallback to default theme
                if (theme !== 'blue') {
                    this.setTheme('blue')
                }
            })

        // Add theme class to body for CSS selectors
        document.body.className = `theme-${theme}`
    },

    // Get current theme
    getCurrentTheme (): string {
        return store.state.theme
    }
}
